import React, { Fragment } from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export const renderPortfolioDetailsButton = (params: GridRenderCellParams<any, any, any>) => {
  return (
    <Fragment>
      <IconButton size="small">
        <InfoIcon fontSize="medium" color="primary"/>
      </IconButton>
    </Fragment>
  );
};
